'use client';
import { useParams } from 'next/navigation';
import { defaultLang, SUPPORTED } from "../../config/languages";
import { getStaticPageSeo } from "../../lib/staticPageSeo";
import PageLayout from "../PageLayout";
import TermsOfUseText from "./text";
import TermsOfUseTextSr from "./text.sr";

const TermsOfUse = () => {
  const { lang = defaultLang, slug } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const seo = getStaticPageSeo('terms', activeLang);

    return (
        <PageLayout 
            showWorkspaceCta
            title={seo.title}
            metaDescription={seo.description}
            canonical={`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/terms`} 
            ogType="article"
        >
            {activeLang === 'sr' ? <TermsOfUseTextSr /> : <TermsOfUseText />}
        </PageLayout>
    );
}

export default TermsOfUse;
